import {type Dispatch, type SetStateAction, useRef} from 'react'

import {
    applyRentalPeriod,
    type QuoteDraft,
    type QuoteLine,
    type QuoteRentalPeriod,
} from './quote-builder-logic'

export function useRentalPeriodLines(setQuote: Dispatch<SetStateAction<QuoteDraft>>) {
    const untickedLineIds = useRef(new Set<string>())

    function updateRentalPeriod(rentalPeriod: QuoteRentalPeriod | null) {
        setQuote((current) => ({
            ...current,
            meta: {...current.meta, rentalPeriod},
            lines: applyRentalPeriod(
                current.lines,
                current.meta.rentalPeriod,
                rentalPeriod,
                untickedLineIds.current,
            ),
        }))
    }

    function updateLines(lines: QuoteLine[]) {
        setQuote((current) => {
            for (const line of lines) {
                const before = current.lines.find((previous) => previous.id === line.id)
                if (line.kind !== 'item' || before?.kind !== 'item') {
                    continue
                }
                if (before.forRentalPeriod && !line.forRentalPeriod) {
                    untickedLineIds.current.add(line.id)
                } else if (!before.forRentalPeriod && line.forRentalPeriod) {
                    untickedLineIds.current.delete(line.id)
                }
            }
            return {...current, lines}
        })
    }

    return {updateRentalPeriod, updateLines}
}
